<form lin-layout-form [formGroup]="form" (ngSubmit)="pairOrUnpairAsset()">
  <lin-form-label required>{{ 'FIELDS.assetId' | translate }}:</lin-form-label>
  <mat-form-field>
    <input matInput formControlName="assetId" />
    <mat-error><lin-form-field-error></lin-form-field-error></mat-error>
  </mat-form-field>

  <div class="info">
    <span>{{ 'FIELDS.model' | translate }}: {{ asset?.model }}</span>
  </div>

  <lin-form-label required>{{ 'FIELDS.sensorId' | translate }}:</lin-form-label>
  <mat-form-field>
    <input linMacAddress matInput formControlName="sensorId" />
    <mat-error><lin-form-field-error></lin-form-field-error></mat-error>
  </mat-form-field>

  <div class="info">
    <span>{{ 'FIELDS.type' | translate }}: {{ sensor?.type.label }}</span>
  </div>

  <lin-form-submit-button [isDisabled]="!asset || !sensor" [isLoading]="isSubmitting"> {{ title }} </lin-form-submit-button>
</form>

@if (isLoading) {
<lin-spinner class="spinner"></lin-spinner>
}
